import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vaccine-schema',
  templateUrl: './vaccine-schema.component.html',
  styleUrls: ['./vaccine-schema.component.scss']
})
export class VaccineSchemaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
